<style  lang="scss" scoped>
.flex {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
}

.A1 {
    color: #1A1A1A;
}

.a {
    color: rgba(66, 94, 178, 1);
    cursor: pointer;
}

.content {
    opacity: 1;
    padding-bottom: 0;
    background: #FFFFFF;
    opacity: 1;
    padding: 20px;
    border-radius: 8px;

    .gridlist {
        margin-top: 20px;
    }

    .label {
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 20px;
    }

    .label-tpis {
        height: 21px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 21px;
        margin-top: 16px;
    }

    .btn {
        margin-top: 16px;
    }

    .list-li {
        .li-card {
            border-radius: 6px;
            height: 167px;
            padding: 0 20px;
            background: #004889;
            &.type_1001{
                background: #B2082D;
            }
            &.type_1002{
                background: #e1071a;
            }
            &.type_1003{
                background: #0168b3;
            }
            &.type_1004{
                background: #0137ab;
            }
            &.type_1005{
                background: #018A6E;
            }
            &.type_1009{
                background: #384184;
            }
            &.type_1032{
                background: #db241c;
            }
            &.type_1022{
                background: #6a1686;
            }
            &.type_1006{
                background: #0168b7;
            }
            &.type_1021{
                background: #e60000;
            }
            &.type_1027{
                background: #ea1b2d;
            }
            &.type_1010{
                background: #de5511;
            }
            &.type_1026{
                background: #c10938;
            }
            &.type_1020{
                background: #0E359B;
            }
            &.type_1066{
                background: #007130;
            }
            &.type_2005{
                background: #29166f;
            }
            &.type_2012{
                background: #2a30d1;
            }
            &.type_2011{
                background: #0078bc;
            }
            &.type_2006{
                background: #142d55;
            }
            &.type_2007{
                background: #005bac;
            }
            &.type_2009{
                background: #e70012;
            }
            &.type_2010{
                background: #ea8414;
            }
            &.type_2008{
                background: #ea8414;
            }
            &.type_2015{
                background: #a82127;
            }
            &.type_2013{
                background: #c51818;
            }
            &.type_2014{
                background: #e15517;
            }
            &.type_2004{
                background: #e60012;
            }
            &.type_2003{
                background: #e60000;
            }
            &.type_2002{
                background: #d62c36;
            }
            .header {
                height: 74px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);

                .img {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background: #fff;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                    .el-image{
                        width:100%;
                        height:100%;
                    }
                    .image-slot {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        overflow:hidden;
                        border-radius:50%;
                        background: var(--el-fill-color-light);
                        color: var(--el-text-color-secondary);
                        font-size: 20px;
                        color:#004889;
                    }
                }

                .bankname {
                    height: 16px;
                    font-size: 16px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 16px;
                    margin-left: 10px;
                    flex: 1;
                }
            }

            .name {
                height: 16px;
                font-size: 16px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 16px;
                margin-top: 20px;
            }

            .bankid {
                @extend .name;
                display: inline-block;
                cursor: pointer;
                padding: 0 28px 0 0;
                position: relative;
                &::after{
                    content:'';
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url('https://p6.moimg.net/path/dst_project/17821/202310/0717/2030/2310072030kaq1RpbPOx0vOb1qKwzK7QnA8w9eYV.png') no-repeat center center;
                    background-size: 18px 18px;
                }
            }
        }

        .li-error {
            height: 48px;
            background: #FFF8EE;
            border-radius: 4px;
            margin-top: 6px;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #F5A728;
            padding: 0 15px;
            >p{
                display:flex;
                align-items:center;
            }
            .icon {
                padding-right:6px;
                font-size: 18px
            }
        }

        .li-ifcard {
            @extend .li-error;
            color: #7F7F7F;
            background: #F8F8F8;
        }
    }

    .card-btn {
        margin-top: 17px;
        width: 280px;
        height: 120px;
        background: #F8F8F8;
        border-radius: 4px;
        opacity: 1;
        border: 1px dashed #E8E8E8;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .icon-box {
            text-align: center;
            padding: 7px 0;
            color: #7F7F7F;
            font-size: 12px;

            .icon {
                font-size: 16px;
                margin-bottom: 10px;
            }
        }
    }
    .op_btn {
        margin: 0;
        width: 95px;
        height: 28px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        opacity: 1;
        border: 1px solid #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;
        &.check{
            background: #FFFFFF;
            font-size: 14px;
            color: #7F7F7F;
            border: 1px solid #B1B1B1;
        }
        .icon{
            padding-right: 3px;
        }
    }
}
.box{
    ::v-deep .el-drawer {
        .el-drawer__body {
            .chooseDrawerContent{
                padding: 0 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .choseItem{
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 240px;
                    height: 135px;
                    box-sizing: border-box;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E8E8E8;
                    font-size: 14px;
                    font-weight: 400;
                    color: #7F7F7F;
                    line-height: 14px;
                    &.active{
                        color: #00C4A1;
                        border: 2px solid #00C4A1;
                        .icon{
                            border-bottom: 1px solid #00C4A1;
                        }
                    }
                    .icon{
                        width: 100%;
                        height: 100px;
                        border-bottom: 1px solid #E8E8E8;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        i{
                            font-size: 40px;
                        }
                    }
                }
            }
            .tips{
                padding: 0 15px;
                display: flex;
                align-items: center;
                width: 560px;
                height: 48px;
                background: #FFF8EE;
                border-radius: 4px;
                font-size: 16px;
                font-weight: 400;
                color: #F5A728;
                line-height: 16px;
                i{
                    font-size: 18px;
                    padding-right: 6px;
                }
            }
            .title{
                font-size: 16px;
                margin: 0;
                font-weight: 400;
                color: #1A1A1A;
                line-height: 16px;
                padding: 20px 0;
            }
            .el-input,.el-form-item__label{
                height: 40px;
                line-height: 40px;
            }
            .el-form-item__content{
                font-size: 16px;
                font-weight: 400;
                color: #1A1A1A;
                line-height: 16px;
            }
            .yzm-btn {
                position: absolute;
                top: 13px;
                right: 12px;
                font-size: 14px;
                font-weight: 400;
                color: #00C4A1;
                line-height: 14px;
                cursor: pointer;
                &.not-allow {
                    cursor: not-allowed;
                    color: #7F7F7F;
                }
            }
            .input_tips{
                margin: 6px 0 0 0;
                font-size: 14px;
                font-weight: 400;
                color: #7F7F7F;
                line-height: 21px;
            }
            .bottom_tips{
                position: relative;
                font-size: 14px;
                font-weight: 400;
                color: #7F7F7F;
                line-height: 21px;
                a{
                    color: #425EB2;
                }
                .el-checkbox--large{
                    position: absolute;
                    left: 0;
                    top: 3px;
                    height: 14px;
                }
                .el-checkbox--large + p{
                    text-indent: 20px;
                }
            }
        }
    }
}
</style>
<template>
    <div class="box">
        <CompHeader title="收款账户">
            <template #nav>
                账户管理
                <span class="icon icon-arrow"></span>
            </template>
        </CompHeader>
        <div class="content">
            <div class="label">
                收款账户
            </div>
            <div class="label-tpis">您已经设置了{{ state.list.length }}个收款账户，最多可以创建10个</div>
            <template v-if="state.list.length">
                <el-button v-if="state.list.length < 10" class="btn" type="primary" @click="addAccount">添加收款账户</el-button>
                <gridList class="gridlist" width="390" column="20" row="20" :auto="false">
                    <div class="list-li" v-for="(item, idx) in state.list" :key="idx">
                        <div :class="`li-card type_${item.bank_type}`">
                            <div class="header">
                                <div class="img">
                                    <el-image class="avtor" :src="$imgUrlFilter(item.bank_logo, 34)">
                                        <template #error>
                                            <div class="image-slot">
                                                <i class="icon-bank"></i>
                                            </div>
                                        </template>
                                    </el-image>
                                </div>
                                <div class="bankname">{{ item.bank_name }}</div>
                                <div class="op_btn" @click="unbindBt(item)">
                                    <span class="icon icon-unlink"></span>
                                    解除绑定
                                </div>
                            </div>
                            <div class="name">{{ item.real_name }}</div>
                            <div class="bankid" @click.stop="copyBankCard(item.id)">{{ formatSensitiveData(item.bank_card,4) }}</div>
                        </div>
                        <div v-if="item.verify_status == 0" class="li-error">
                            <p>
                                <span class="icon icon-info2"></span>
                                账户未通过验证
                            </p>
                            <div class="op_btn check" @click="openYanZheng(item)">立即验证</div>
                        </div>
                        <!-- <div v-if="item.if_card" class="li-ifcard">
                            <span class="icon icon-authentication"></span>
                            身份认证账户
                        </div> -->
                    </div>
                </gridList>
            </template>
            <template v-else>
                <div class="card-btn" @click="addAccount">
                    <div class="icon-box">
                        <div class="icon icon-plus"></div>
                        <div>添加收款账户</div>
                    </div>
                </div>
            </template>
        </div>
        <new-payee :show="newPayeeShow" @updateShow="updateShow"></new-payee>
        <!-- 选择验证方式 -->
        <el-drawer v-model="state.chooseDrawerVisible" size="600px" title="请选择验证方式" :closeOnClickModal="false">
            <div class="chooseDrawerContent">
                <div :class="['choseItem',{'active':state.choseType == chosItem.type}]" v-for="(chosItem, choseIdx) in chose_list" :key="choseIdx" @click.stop="state.choseType = chosItem.type">
                    <div class="icon">
                        <el-icon v-if="chosItem.type == 0"><Cellphone /></el-icon>
                        <i v-else class="icon-pay"></i>
                    </div>
                    <el-radio-group v-model="state.choseType">
                        <el-radio :label="chosItem.type" size="large">{{chosItem.text}}</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" @click.stop="goYanZheng">去验证</el-button>
            </template>
        </el-drawer>
        <!-- 短信验证码 -->
        <el-drawer v-model="state.phoneDrawerVisible" size="600px" title="验证收款账号" :closeOnClickModal="false">
            <div class="moneyDrawerContent">
                <div class="tips">
                    <i class="icon-warning"></i>重要提示：仅支持提现到已验证通过的银行卡
                </div>
                <p class="title">输入银行卡绑定的手机号，查收验证码后进行验证</p>
                <el-form :rules="rules" :model="mobileForm" label-position="left">
                    <div class="form-box">
                        <el-form-item label-width="100" label="手机号" prop="mobile">
                            <el-input v-model="mobileForm.mobile" placeholder="请输入11位手机号" @input="handleMobileInput" />
                            <div :class="['yzm-btn', {'not-allow': mobileForm.verifying}]" @click="getVerify">{{mobileForm.verifying ? `重新发送(${mobileForm.time})`  :'获取验证码'}}</div>
                        </el-form-item>
                        <el-form-item label-width="100" label="验证码" prop="check_code">
                            <el-input v-model="mobileForm.check_code" placeholder="请输入验证码" />
                        </el-form-item>
                    </div>
                </el-form>
                <div class="bottom_tips">
                    <el-checkbox v-model="state.checkJZB" label="" size="large" />
                    <p>已阅读并同意<a href="https://br.pingan.com/ttest" target="_blank">《平安银行“平安结算通”商户服务协议》</a>和<a href="https://auth.orangebank.com.cn/#/m/cDealOne?showNavBar=1" target="_blank">《平安数字用户服务协议》</a>平安银行将为您提供银行账号认证等服务。</p>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" @click.stop="smsCheck">提交验证</el-button>
            </template>
        </el-drawer>
        <!-- 打款验证Step1 -->
        <el-drawer v-model="state.moneyDrawerVisible" size="600px" title="验证收款账号" :closeOnClickModal="false">
            <div class="moneyDrawerContent">
                <div class="tips">
                    <i class="icon-warning"></i>重要提示：仅支持提现到已验证通过的银行卡
                </div>
                <p class="title">摩点将对需要验证的账户打款，请查询并输入打款金额</p>
                <el-form :rules="rules" :model="mobileForm" label-position="left">
                    <div class="form-box">
                        <el-form-item label-width="100" label="手机号" prop="mobile">
                            <el-input v-model="mobileForm.mobile" placeholder="请输入11位手机号，用于接受汇款状态通知" @input="handleMobileInput" />
                        </el-form-item>
                    </div>
                </el-form>
                <div class="bottom_tips">
                    <el-checkbox v-model="state.checkJZB" label="" size="large" />
                    <p>已阅读并同意<a href="https://br.pingan.com/ttest" target="_blank">《平安银行“平安结算通”商户服务协议》</a>和<a href="https://auth.orangebank.com.cn/#/m/cDealOne?showNavBar=1" target="_blank">《平安数字用户服务协议》</a>平安银行将为您提供银行账号认证等服务。</p>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" @click.stop="mallPaymeny">申请鉴权</el-button>
            </template>
        </el-drawer>
        <!-- 打款验证Step2 -->
        <el-drawer v-model="state.lastMoneyDrawerVisible" size="600px" title="验证收款账号" :closeOnClickModal="false">
            <div class="moneyDrawerContent">
                <div class="tips" style="margin-bottom:10px;">
                    <i class="icon-warning"></i>重要提示：仅支持提现到已验证通过的银行卡
                </div>
                <el-form :rules="rules" :model="mobileForm" label-position="left">
                    <div class="form-box">
                        <el-form-item label-width="100" label="鉴权序号">
                            <el-input v-model="mobileForm.check_code" placeholder="请填入鉴权序号" />
                            <p class="input_tips">请留意手机号 {{mobileForm.mobile}} 收到的鉴权序号</p>
                        </el-form-item>
                        <el-form-item label-width="100" label="银行卡号">
                            {{formatSensitiveData(state.bank_card,4)}}（{{state.bank_name}}）
                        </el-form-item>
                        <el-form-item label-width="100" label="收款金额">
                            <el-input v-model="mobileForm.money" placeholder="请填入账户中收到的金额" />
                        </el-form-item>
                    </div>
                </el-form>
                <div class="bottom_tips">
                    <p>已申请对需要验证的银行账号打款，请您在24h内查询上方银行账号的收款记录（摘要：平台小额鉴权支付），输入金额完成验证。</p>
                    <p>打款金额数字24小时内有效（如果您在24小时内曾为本银行账号申请打款验证，平台将不会重复给您打款，请查24小时内收到的打款金额）。</p>
                </div>
            </div>
            <template #footer>
                <el-button type="primary" @click.stop="paymentCheck">提交</el-button>
            </template>
        </el-drawer>
        <!-- 复制 -->
        <el-drawer v-model="state.copyDrawerVisible" size="600px" title="卡号信息" :closeOnClickModal="false">
            <div class="moneyDrawerContent">
                {{state.bank_card}}（{{state.bank_name}}）
            </div>
            <template #footer>
                <el-button @click="state.copyDrawerVisible = false;">取消</el-button>
                <el-button type="primary" class="copy-button" :data-clipboard-text="state.bank_card" @click="copy">复制卡号</el-button>
            </template>
        </el-drawer>
    </div>
</template>
  
<script setup>
import {
    // eslint-disable-next-line no-unused-vars
    ref,
    // eslint-disable-next-line no-unused-vars
    watch,
    onBeforeMount,
    // eslint-disable-next-line no-unused-vars
    onMounted,
    reactive,
    // eslint-disable-next-line no-unused-vars
    defineExpose,
    // eslint-disable-next-line no-unused-vars
    computed,
    onBeforeUnmount,
} from "vue";
import { getShroffList, accountUnbind, sendVcode, postSmsCheck, postMallPaymeny, smallPaymentCheck, getBankCard, getUserAuthStatus, checkCreateAccount } from '@/api/index';
// eslint-disable-next-line no-unused-vars
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import CompHeader from "@@/common/header.vue";
import newPayee from "./new_payee.vue";
import gridList from "@@/common/gridList.vue";
// eslint-disable-next-line no-unused-vars
import { ElMessage, ElMessageBox } from "element-plus";
import tools from '@/utils/tools.js'
import Clipboard from 'clipboard'
import domain from '@/service/domain'
// eslint-disable-next-line no-unused-vars
const store = useStore();
// eslint-disable-next-line no-unused-vars
const router = useRouter();
const newPayeeShow = ref(false)
// const domain_zhongchou = domain.zhongchou;
onBeforeMount(async () => {
    getList();
});
onBeforeUnmount(() => { });
const chose_list = computed(() =>
    state.verify_type == 2 ? [
        {
            type:0,
            text:'短信验证码'
        },
        {
            type:1,
            text:'打款验证'
        }
    ] : [
        {
            type:1,
            text:'打款验证'
        }
    ]
)
// eslint-disable-next-line no-unused-vars
const state = reactive({
    list: [],
    chooseDrawerVisible: false, //验证方式
    choseType:0,
    phoneDrawerVisible: false,
    moneyDrawerVisible: false,
    lastMoneyDrawerVisible: false,
    copyDrawerVisible: false,
    shroff_id: 0,
    union_pay_number: 0,
    checkJZB: false,
    bank_card: '',
    bank_name: '',
    verify_type: 2
})
const mobileForm = reactive({
    mobile:'',
    verifying: false, // 是否正在发送验证码
    time: 60,
    check_code:'',
    money: ''
})
function updateShow() {
    newPayeeShow.value = false
    getList();
}

const getList = async () => {
    const {data} = await getShroffList({})
    state.list = data
}
// 立即验证
const openYanZheng = async item => {
    const {data} = await getUserAuthStatus({})
    if(Number(data.auth_status) == 200){
        // 认证通过，企业的只有打款，个人的看verify_type
        if(Number(data.auth_cate) == 21){
            state.verify_type = 1;
            state.choseType = 1;
        }else{
            state.verify_type = item.verify_type;
            state.choseType = item.verify_type == 2 ? 0 : 1;
        }
        state.checkJZB = false;
        state.bank_card = '';
        state.bank_name = '';
        mobileForm.mobile = '';
        mobileForm.verifying = false;
        mobileForm.time = 60;
        mobileForm.check_code = '';
        mobileForm.money = '';
        state.shroff_id = item.id;
        state.union_pay_number = item.union_pay_number;
        state.chooseDrawerVisible = true;
    }else{
        tools.toast('本账号通过摩点账号认证后，才可验证收款账户');
        // tools.confirm({
        //     title:'提示',
        //     hasCancel:false,
        //     success:'前往认证',
        //     msg:'本账号通过摩点认证后，才可验证收款账户',
        // },() => {
        //     let newTab = window.open('about:blank');
        //     newTab.location.href = domain_zhongchou+'/auth/auth_console';
        // });
    }
}
// 选择验证方式
const goYanZheng = () => {
    state.checkJZB = false;
    if(state.choseType == 0){
        state.phoneDrawerVisible = true;
    } else {
        state.moneyDrawerVisible = true;
    }
    state.chooseDrawerVisible = false;
}
// 打款验证第一步
const mallPaymeny = async () => {
    if (!mobileForm.mobile) {
        tools.toast('请输入11位手机号');
        return false;
    }
    if (!state.checkJZB) {
        tools.toast('请勾选用户服务协议');
        return false;
    }
    const {status, message} = await postMallPaymeny({
        id: state.shroff_id,
        mobile: mobileForm.mobile,
        union_pay_number: state.union_pay_number
    })
    if (status == 0) {
        getBankCardNumber();
        state.moneyDrawerVisible = false;
        state.lastMoneyDrawerVisible = true;
    } else {
        tools.confirm(message);
    }
}
// 打款最后一步
const paymentCheck = async () => {
    if (!mobileForm.check_code) {
        tools.toast('请输入验证码');
        return false;
    }
    if (!mobileForm.money) {
        tools.toast('请输入收款金额');
        return false;
    }
    const {status, message} = await smallPaymentCheck({
        id: state.shroff_id,
        order_no: mobileForm.check_code,
        check_code: mobileForm.money
    })
    if (status == 0) {
        tools.confirm({
            msg: message || '操作成功'
        },() => {
            getList();
            state.lastMoneyDrawerVisible = false;
        })
    } else {
        tools.confirm(message);
    }
}
// 短信验证
const smsCheck = async () => {
    if (!mobileForm.check_code) {
        tools.toast('请输入验证码');
        return false;
    }
    if (!state.checkJZB) {
        tools.toast('请勾选用户服务协议');
        return false;
    }
    const {status, message} = await postSmsCheck({
        id:state.shroff_id,
        check_code:mobileForm.check_code
    })
    if (status == 0) {
        tools.confirm({
            msg: message || '操作成功'
        },() => {
            getList();
            state.phoneDrawerVisible = false;
        })
    } else {
        tools.confirm(message);
    }
}
// 发送验证码
const getVerify = () => {
    if(mobileForm.verifying) return
    if (!mobileForm.mobile) {
        tools.toast('请输入11位手机号');
        return false;
    }
    sendVcode({
        id: state.shroff_id,
        mobile: mobileForm.mobile,
        union_pay_number: state.union_pay_number
    }).then(res => {
        if (res.status == 0) {
            mobileForm.verifying = true
            const timer = setInterval(() => {
                mobileForm.time --
                if (mobileForm.time <= 0) {
                    clearInterval(timer)
                    mobileForm.verifying = false
                    mobileForm.time = 60
                }
            }, 1000)
        } else {
            tools.confirm(res.message);
        }
    })
}
// 获取银行卡号
const getBankCardNumber = async () => {
    const {data} = await getBankCard({id:state.shroff_id})
    state.bank_card = data.bank_card;
    state.bank_name = data.bank_name;
}
const unbindBt = async (item) => {
    ElMessageBox.confirm(
            `确定要解除${item.bank_name}${item.bank_card}账户吗？`,
            "提示",
            {
                autofocus: false,
                showCancelButton: true,
                dangerouslyUseHTMLString: false,
                cancelButtonText: "取消",
                confirmButtonText: "确定解绑",
            }
        ).then(async () => {
            await accountUnbind({ id: item.id })
            getList();
        });
}
// 用户手机号校验
const handleMobileInput = () => {
    mobileForm.mobile = mobileForm.mobile.replace(/\D/g, "");
    if (mobileForm.mobile.length > 11) {
        mobileForm.mobile = mobileForm.mobile.slice(0, 11);
    }
}
const copyBankCard = (id) => {
    state.shroff_id = id;
    getBankCardNumber();
    state.copyDrawerVisible = true;
}
const copy = () => {
    let copyButton = document.querySelector('.copy-button');
    let clipboard = new Clipboard(copyButton);
    clipboard.on('success', function(e) {
        e.clearSelection()
        ElMessage({
            type: 'warning',
            message: '复制成功！',
            customClass: 'waring-customize',
        })
        clipboard.destroy()
        state.copyDrawerVisible = false;
    })
    clipboard.on('error', function() {
        ElMessage({
            message: '复制失败！',
            customClass: 'info-customize',
            type: 'info',
        })
        clipboard.destroy()
    })
}
const formatSensitiveData = (data, spacing) => {
  const regex = new RegExp(`(.{${spacing}})`, 'g');
  return data.replace(regex, '$1 ');
}
const addAccount = async () => {
    const {data} = await checkCreateAccount({})
    if(data.available){
        newPayeeShow.value = true
    }else{
        tools.confirm({
            msg: data.msg
        },() => {

            //如果需要重新认证
            if (data.need_auth) {
                 window.open(`${domain.www}/identity/type`)
            }
        })
    }
}
</script>

  